<template>
    <div>
        <a
            class="btn btn-md is-ghost px-2xl"
            @click="$modal.show('activate-company')"
        >
            Aktivera
        </a>
        <adaptive-form-modal
            name="activate-company"
            primary-button-text="Aktivera entrepenören"
            primary-button-class="is-primary"
            title="Aktivera entrepenör"
            :redirect-to="route('admin.companies.index')"
            method="patch"
            :action="route('api.companies.activate', company)"
        >
            Vill du verkligen aktivera {{ company.name }}?
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            company: {
                type: Object,
                required: true,
            },
        },
    };
</script>
